let currentIndex = 0;
const items = document.querySelectorAll('.carousel-item');
const nextButton = document.querySelector('.carousel-button-next');
const prevButton = document.querySelector('.carousel-button-prev');

function showSlide(index) {
    if (index >= items.length) {
        currentIndex = 0;  // 循环到第一个
    } else if (index < 0) {
        currentIndex = items.length - 1;  // 循环到最后一个
    } else {
        currentIndex = index;
    }
    const offset = -100 * currentIndex;  // 计算当前项的位移
    document.querySelector('.carousel-container').style.transform = `translateX(${offset}%)`;
}

nextButton.addEventListener('click', function () {
    showSlide(currentIndex + 1);
});

prevButton.addEventListener('click', function () {
    showSlide(currentIndex - 1);
});

// 初始化显示第一张
showSlide(currentIndex);
